import {
  Button,
  TEOLoader,
  InputText,
  Checkbox,
  IconButton,
} from '@teo/components';
import { ChevronDown, Search, ChevronUp } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useGet } from '@/query';
import { PaginationAnything } from '@/components/DataTable/PaginationAnything';
import TextWithTooltip from '@/pages/Protected/Manage/Competencies/TextWithTooltip';

const NodeItem = ({
  item,
  exists = false,
  hendleAdd,
  hendleDelete,
  listCompetencies,
}) => {
  const [isExists, steIsExists] = useState(
    listCompetencies?.some((el) => el.competenceId === item.competenceId)
  );

  useEffect(() => {
    steIsExists(
      listCompetencies?.some((el) => el.competenceId === item.competenceId)
    );
  }, [exists]);

  const handleMandatory = (item, isCheck) => {
    steIsExists(isCheck);
    if (isCheck) {
      hendleAdd(item);
    } else {
      hendleDelete(item);
    }
  };

  return (
    <div className={`flex w-full rounded-lg border`}>
      <div className="flex w-full items-center gap-2 px-3 py-2 text-black">
        <div
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Checkbox
            checked={isExists}
            onChange={(isChecked) => {
              handleMandatory(item, isChecked);
            }}
          />
        </div>
        {item?.name}
        <div className="ml-auto flex min-w-max items-center gap-2">
          {item?.competenceCategoryId && (
            <>
              {item?.code && (
                <div className="rounded-[4px] bg-grey-02 px-2 py-0.5 text-xs text-grey-06">
                  {item?.code}
                </div>
              )}
              <p className="flex min-w-max items-center text-sm text-grey-08">
                <span
                  style={{
                    backgroundColor: item?.competenceCategoryColorCode,
                  }}
                  className={`mr-2 h-2 w-2 min-w-2 rounded-full`}
                ></span>
                {item?.competenceCategoryName}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const AddCompetenceList = ({
  setDeleteList,
  deleteList,
  setAddList,
  addList,
  oldCompetencies,
  listCompetencies,
  setNewLesCompetencies,
}) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user;

  const [showAddList, setShowAddList] = useState(false);

  const [loadCompetencies, setLoadCompetencies] = useState(true);
  const [sort, setSort] = useState([{ id: 'competenceId', desc: false }]);

  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 250);
    return () => clearTimeout(t);
  }, [filter]);

  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.competenceId));

    const resultList = [
      ...oldCompetencies.filter((item) => !deletedIds.has(item.competenceId)),
      ...addList.map((item) => ({
        ...item,
      })),
    ];
    setNewLesCompetencies(resultList);
  }, [addList, deleteList, oldCompetencies]);

  const hendleDelete = (item) => {
    const existsAdd = addList?.find(
      (el) => el?.competenceId === item.competenceId
    );
    if (existsAdd) {
      setAddList((prev) =>
        prev?.filter((el) => el?.competenceId !== item.competenceId)
      );
    } else {
      setDeleteList((prev) => [...prev, item]);
    }
  };
  const hendleAdd = (item) => {
    const existsDelete = deleteList?.find(
      (el) => el?.competenceId === item.competenceId
    );
    if (existsDelete) {
      setDeleteList((prev) =>
        prev?.filter((el) => el?.competenceId !== item.competenceId)
      );
    } else {
      setAddList((prev) => [...prev, item]);
    }
  };

  return (
    <div className="-my-6 -ml-6 -mr-6 flex flex-col py-6">
      <div className="flex flex-col gap-1">
        <div className="mb-3 flex flex-col px-6">
          <h3 className="mb-2 text-base">
            {t('pages.manage_competencies.add_competence')}
          </h3>
          <p className="text-sm text-grey-06">
            {t('pages.create_edit_course.competence_add.add_madal_text')}
          </p>
          {listCompetencies?.length > 0 && (
            <div className="mb-2 flex w-full flex-col gap-2 border-b py-6">
              <div className="flex items-center gap-2 rounded-md bg-grey-01 px-4 py-1">
                {' '}
                {listCompetencies?.length}{' '}
                {listCompetencies?.length > 1
                  ? t('pages.create_edit_course.competence_add.competencies')
                  : t('pages.create_edit_course.competence_add.competence')}
                {t('pages.create_edit_course.competence_add.added')}
                <div className="ml-auto">
                  <IconButton
                    Icon={showAddList ? ChevronUp : ChevronDown}
                    ariaLabel="Search"
                    onClick={() => setShowAddList(!showAddList)}
                    variant="ghost"
                  />
                </div>
              </div>
              {showAddList &&
                listCompetencies?.map((item) => {
                  return (
                    <NodeItem
                      key={item?.competenceId}
                      item={item}
                      exists={true}
                      hendleAdd={hendleAdd}
                      hendleDelete={hendleDelete}
                      listCompetencies={listCompetencies}
                    />
                  );
                })}
            </div>
          )}
        </div>
        <div className={`relative mb-2 px-6`}>
          <InputText
            value={filter}
            onChange={(ev) => setFilter(ev.target.value)}
            Icon={Search}
            placeholder={t('pages.create_edit_course.competence_add.search')}
          />
        </div>
        <div className="mt-2 flex w-full flex-col px-6">
          {loadCompetencies && (
            <div className="mx-auto flex justify-center py-20 px-10">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[100px]"
              />
            </div>
          )}
          <PaginationAnything
            className={`mt-3 flex w-full flex-col gap-2 ${
              loadCompetencies === true && ' hidden '
            }`}
            fetch={useGet.bind(null, '/organisationcompetencedetails', {
              lang: authUser?.lang,
              organisationId: `${authUser?.activeOrganisationId},OR,organisationId=null`,
              disabled: false,
              onSuccess: (result) => {
                setLoadCompetencies(false);
              },
            })}
            empty={{
              template: 2,
              loadContent: loadCompetencies,
              text: t('empty_tenplate.course_list'),
            }}
            defaultSort={sort}
            page={0}
            pageSize={10}
            filter={debouncedFilter}
            render={(comp) => {
              const isExists = listCompetencies?.find(
                (el) => el.competenceId === comp.competenceId
              );
              return (
                <NodeItem
                  key={comp?.competenceId}
                  item={comp}
                  exists={isExists}
                  hendleAdd={hendleAdd}
                  hendleDelete={hendleDelete}
                  listCompetencies={listCompetencies}
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddCompetenceList;
